/** Public branded-app legal pages (privacy policy, terms of service). */
export const CP_PUBLIC_LEGAL_ROUTE_PREFIX = '/legal/' as const

export const isCPLegalRoutePath = (path?: string): boolean => typeof path === 'string' && path.startsWith(CP_PUBLIC_LEGAL_ROUTE_PREFIX)
